import { render, staticRenderFns } from "./RelocateDialog.vue?vue&type=template&id=570eb9e9&"
import script from "./RelocateDialog.vue?vue&type=script&lang=js&"
export * from "./RelocateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports